import { useZustandStore } from 'zustandGlobalStore'
import { getAxonUserData } from './getAxonUserData'

export const sendAxonEvent = (
  event: string,
  data: Record<string, unknown> = {},
): void => {
  if (typeof window === 'undefined' || typeof window.axon !== 'function') {
    return
  }

  const state = useZustandStore.getState()
  const userData = getAxonUserData(
    state.lead?.id,
    state.lead?.email || state.inputEmail,
  )

  window.axon('track', event, {
    ...data,
    ...(Object.keys(userData).length ? { user_data: userData } : {}),
  })
}
